function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var canvas = document.getElementById('canvas');
if (canvas === null) throw new Error('Cannot find an element with id canvas');
var canvasWidth = canvas.width = canvas.offsetWidth;
var canvasHeight = canvas.height = canvas.offsetHeight;
var zoom = canvasWidth / 5;
var centerX = 0;
var centerY = 0;
var iteration = 100;
function calcMandelbrot(c, d) {
    // Z = a+bxi, C = c+dxi
    var a = 0;
    var b = 0;
    for(var n = 0; n < iteration; n++){
        var aa = a * a;
        var bb = b * b;
        var na = aa - bb + c;
        var nb = 2 * a * b + d;
        a = na;
        b = nb;
        if (aa + bb > 4) return n;
    }
    return -1;
}
function draw() {
    return _draw.apply(this, arguments);
}
function _draw() {
    _draw = _async_to_generator(function() {
        var ctx, id, pixels, x, y, dx, dy, c, d, mandelbrotValue, off, r, g, b;
        return _ts_generator(this, function(_state) {
            ctx = canvas.getContext('2d');
            if (ctx === null) throw new Error('Canvas doesn\'t have a 2d context');
            ctx.clearRect(0, 0, canvasWidth, canvasHeight);
            id = ctx.getImageData(0, 0, canvasWidth, canvasHeight);
            pixels = id.data;
            for(x = 0; x <= canvasWidth; x++){
                for(y = 0; y <= canvasWidth; y++){
                    dx = x - canvasWidth / 2;
                    dy = y - canvasHeight / 2;
                    c = dx / zoom + centerX;
                    d = dy / zoom + centerY;
                    mandelbrotValue = calcMandelbrot(c, d);
                    off = (y * id.width + x) * 4;
                    if (mandelbrotValue == -1) {
                        pixels[off] = 0;
                        pixels[off + 1] = 0;
                        pixels[off + 2] = 0;
                    } else {
                        r = Math.floor(128 + 127 * Math.sin(0.1 * mandelbrotValue));
                        g = Math.floor(128 + 127 * Math.sin(0.15 * mandelbrotValue + Math.PI / 3));
                        b = Math.floor(128 + 127 * Math.sin(0.2 * mandelbrotValue + Math.PI / 2));
                        pixels[off] = r;
                        pixels[off + 1] = g;
                        pixels[off + 2] = b;
                    }
                    pixels[off + 3] = 255;
                }
            }
            ctx.putImageData(id, 0, 0);
            return [
                2
            ];
        });
    });
    return _draw.apply(this, arguments);
}
document.addEventListener('mousedown', function(event) {
    var dx = event.clientX - canvasWidth / 2;
    var dy = event.clientY - canvasHeight / 2;
    var c = dx / zoom + centerX;
    var d = dy / zoom + centerY;
    zoom = zoom * 2;
    centerX = c;
    centerY = d;
    iteration = iteration * 1.25;
    draw();
});
draw();
